<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <!-- <v-col cols="12" lg="12">
        <v-card class="py-5">
          <v-toolbar flat>
           <v-col cols="12" class="px-0 py-5">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Distributor
                    <div class="month-label">
                      {{
                        `${formatDate(this.dates[0])} - ${formatDate(
                          this.dates[1]
                        )}`
                      }}
                      Report
                    </div>
                  </v-toolbar-title>
                </div>
                <div class="ml-auto d-flex">
                  <v-dialog
                    ref="dialog"
                    v-model="modal"
                    :return-value.sync="dates"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="primary" v-bind="attrs" v-on="on">
                        <v-icon class="mr-2">mdi-calendar</v-icon> Choose Dates
                      </v-btn>
                    </template>
                    <v-date-picker v-model="dates" range>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog.save(dates)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </div>
              </div>
            </v-col> 
          <v-spacer></v-spacer> 
          </v-toolbar>

         <v-divider></v-divider> 
        </v-card>
      </v-col> -->
      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Distributor
                    <div class="month-label">
                      {{
                      this.selectedDate
                      }}
                      Report
                    </div>
                  </v-toolbar-title>
                </div>
                <div class="ml-auto d-flex">
                  <v-dialog
                    ref="dialog"
                    v-model="modal"
                    :return-value.sync="date2"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="primary mx-2" v-bind="attrs" v-on="on">
                        <v-icon class="mr-2">mdi-calendar</v-icon> Choose Month
                      </v-btn>
                    </template>
                    <v-date-picker v-model="date2"   type="month">
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="SendRange(date2)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                 
                  <v-btn color="primary" class="ml-2">
                    <download-csv :data="exportData" :name="`${fileName}.csv`" :disabled="!exportData.length">
                      <v-icon dense>mdi-download</v-icon>
                      Export
                    </download-csv>
                  </v-btn>
                  <v-btn color="primary mx-2" @click="goBack()">
                    <v-icon class="mr-2">mdi-arrow-left</v-icon> Back
                  </v-btn>
                  <v-btn color="primary mx-2" @click="getList()">
                    <v-icon class="mr-2">mdi-refresh</v-icon> Refresh Page
                  </v-btn>
                </div>
                <!-- <div class="ml-auto">
                  <v-btn color="primary" @click="goBack()">
                    <v-icon class="mr-2">mdi-arrow-left</v-icon> Back
                  </v-btn>
                </div> -->
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card-title>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
              hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="table.headers" :items="table.data" :items-per-page="10" :loading="table.loading"
            item-key="area" :search="search" loading-text="Loading... Please wait" class="elevation-1">
            <!-- <template v-slot:[`item.ConversionRate`]="{ item }">
              {{ Number(item.ConversionRate).toFixed(2) }}
            </template> -->
            <template v-for="header in table.headers.filter((header) =>
              header.hasOwnProperty('formatter')
            )" v-slot:[`item.${header.value}`]="{ value }">
              {{ header.formatter(value) }}
            </template>
            <template v-slot:[`item.forConfirmation`]="{ item }">
              <a href="#" @click.prevent="showForConfirmation(item, 'FOR_CONFIRMATION')">{{
                setToLocaleString(item.forConfirmation, 0) }}</a>
            </template>
            <template v-slot:[`item.interested`]="{ item }">
              <a href="#" @click.prevent="showInterested(item, 'INTERESTED')">{{
                setToLocaleString(item.interested, 0)
              }}</a>
            </template>
            <template v-slot:[`item.onSiteVisit`]="{ item }">
              <a href="#" @click.prevent="showforOnSiteVisit(item, 'ON_SITE_VISIT')">{{
                setToLocaleString(item.onSiteVisit, 0) }}</a>
            </template>
            <template v-slot:[`item.forInstallation`]="{ item }">
              <a href="#" @click.prevent="showforInstallation(item, 'FOR_INSTALLATION')">{{
                setToLocaleString(item.forInstallation, 0) }}</a>
            </template>
            <template v-slot:[`item.onuRetrieval`]="{ item }">
              <a href="#" @click.prevent="showforONURetrieval(item, 'ONU_RETRIEVAL')">{{
                setToLocaleString(item.onuRetrieval, 0) }}</a>
            </template>
            <template v-slot:[`item.forChangeNap`]="{ item }">
              <a href="#" @click.prevent="showforChangeNap(item, 'FOR_CHANGE_NAP')">{{
                setToLocaleString(item.forChangeNap, 0) }}</a>
            </template>
            <template v-slot:[`item.activated`]="{ item }">
              <a href="#" @click.prevent="showActivated(item, 'ACTIVATIONS')">{{
                setToLocaleString(item.activated, 0)
              }}</a>
            </template>
            <!-- <template v-slot:expanded-item="{ headers, item }">
              <td class="p-0" :colspan="headers.length">
                <v-data-table
                  :headers="headers"
                  :items="item.areas"
                  :loading="table.loading"
                  :single-expand="table.singleExpand"
                  :expanded.sync="table.expanded"
                  show-expand
                  item-key="area"
                  hide-default-footer
                  loading-text="Loading... Please wait"
                  class="sub-areas"
                >
                  <template v-slot:[`item.data-table-expand`]></template>
                </v-data-table>
              </td>
            </template>

           

            <template v-slot:[`item.isPaid`]="{ item }">
              {{ item.isPaid ? "Yes" : "No" }}
            </template>

            <template v-slot:[`item.amountPaid`]="{ item }">
              {{ item.amountPaid ? item.amountPaid.toLocaleString() : 0 }}
            </template>

            <template v-slot:[`item.todayRevenue`]="{ item }">
              {{ item.todayRevenue ? item.todayRevenue.toLocaleString() : 0 }}
            </template> -->
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <PdsDetails ref="pdsDetails" />
    <pdsDetails_Interested ref="pdsDetails_Interested" :key="`pdsDetails_${componentKey}`" />
    <pdsDetails_forInstallation ref="pdsDetails_forInstallation" :key="`pdsDetails_forInstallation_${componentKey}`" />
    <pdsDetails_OnSiteVisit ref="pdsDetails_OnSiteVisit" :key="`pdsDetails_OnSiteVisit_${componentKey}`" />
    <pdsDetails_forChangeNap ref="pdsDetails_forChangeNap" :key="`pdsDetails_forChangeNap_${componentKey}`" />
    <pdsDetails_Activated ref="pdsDetails_Activated" :key="`pdsDetails_Activated_${componentKey}`" />
    <pdsDetails_ONURetrieval ref="pdsDetails_ONURetrieval" :key="`pdsDetails_ONURetrieval_${componentKey}`" />
  </v-container>
</template>

<script>
import moment from "moment";
import ShareableMethods from "../../mixins/ShareableMethods";
import PdsDetails from "../dialogs/pds/pdsDetails.vue";
import pdsDetails_Interested from "../dialogs/pds/pdsDetails_Interested.vue";
import pdsDetails_forInstallation from "../dialogs/pds/pdsDetails_forInstallation.vue";
import pdsDetails_OnSiteVisit from "../dialogs/pds/pdsDetails_OnSiteVisit.vue";
import pdsDetails_forChangeNap from "../dialogs/pds/pdsDetails_forChangeNap.vue";
import pdsDetails_Activated from "../dialogs/pds/pdsDetails_Activated.vue";
import pdsDetails_ONURetrieval from "../dialogs/pds/pdsDetails_ONURetrieval.vue";
export default {
  mixins: [ShareableMethods],
  components: {
    PdsDetails,
    pdsDetails_Interested,
    pdsDetails_forInstallation,
    pdsDetails_OnSiteVisit,
    pdsDetails_forChangeNap,
    pdsDetails_Activated,
    pdsDetails_ONURetrieval,
  },
  data() {
    return {
      componentKey: Math.random(),
      exportData: [],
      fileName: "",
      menu: false,
      modal: false,
      selectedDate:"",
      date2:moment()
          .startOf("month")
          .format("YYYY-MM"),
   
      search: "",
      table: {
        page: 0,
        total: 0,
        numberOfPages: 0,

        expanded: [],
        singleExpand: false,
        sortBy: "dtCreated",
        sortDesc: true,
        loading: false,
        headers: [
          { text: "Distributor", value: "distributorName" },
          {
            text: "For Confirmation",
            align: "center",
            value: "forConfirmation",
            formatter: (x) => (x ? this.setToLocaleString(x, 0) : 0),
          },
          {
            text: "Interested",
            align: "center",
            value: "interested",
            formatter: (x) => (x ? this.setToLocaleString(x, 0) : 0),
          },
          {
            text: "For On-site Visit",
            align: "center",
            value: "onSiteVisit",
            formatter: (x) => (x ? this.setToLocaleString(x, 0) : 0),
          },
          {
            text: "For Installation",
            align: "center",
            value: "forInstallation",
            formatter: (x) => (x ? this.setToLocaleString(x, 0) : 0),
          },
          {
            text: "For ONU Retrieval",
            align: "center",
            value: "onuRetrieval",
            formatter: (x) => (x ? this.setToLocaleString(x, 0) : 0),
          },
          {
            text: "For Change Nap",
            align: "center",
            value: "forChangeNap",
            formatter: (x) => (x ? this.setToLocaleString(x, 0) : 0),
          },
          {
            text: "Activated",
            align: "center",
            value: "activated",
          },
          // { text: "", value: "data-table-expand" },
        ],
        data: [],
        options: {
          page: 1,
        },
      },
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    async getList() {
      this.table.loading = true;
      await this.$pds
        .get(`/pds/report`)
        .then((response) => {
          const newArr = response.data.data;
          this.table.data = newArr.reports;
          this.table.loading = false;
          this.exportExcel(newArr.reports);
          this.selectedDate="Overall";
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },
    SendRange(date){
     // const { params } = this.$route;
     // const output = moment(date, "YYYY-MM");
     this.selectedDate=date;
      this.table.loading = true;
       this.$pds
        .get(`/pds/report?date=`+date)
        .then((response) => {
          const newArr = response.data.data;
          this.table.data = newArr.reports;
          this.table.loading = false;
          this.exportExcel(newArr.reports);

        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
//       const startDate=output.startOf('month').format("YYYY-MM-DD");
//       const endDate=output.endOf('month').format("YYYY-MM-DD");
// console.log('Start of the month:', output.startOf('month').format('LL'));
// console.log('End of the month:', output.endOf('month').format('LL'));
//     this.getTicket(params.id,startDate,endDate);
    this.modal=false;
    
    },

    viewDrawDetail(data) {
      this.$store.dispatch("addDrawDetails", data);
      this.$router
        .push({ path: `${this.$route.matched[0].path}/draw/view/${data.id}` })
        .catch(() => { });
    },

    row_classes() {
      return "row_classes";
    },

    formatDate(d) {
      return moment(d).format("MMM DD, YYYY");
    },
    async showForConfirmation(item, status) {
      console.log(item);
      console.log(status);
      await this.$refs.pdsDetails.open(item, status).then(() => {
        this.componentKey = Math.random();
      });
    },
    async showInterested(item, status) {
      console.log(item);
      console.log(status);
      await this.$refs.pdsDetails_Interested.open(item, status).then(() => {
        this.componentKey = Math.random();
      });
    },
    async showforInstallation(item, status) {
      console.log(item);
      console.log(status);
      await this.$refs.pdsDetails_forInstallation
        .open(item, status)
        .then(() => {
          this.componentKey = Math.random();
        });
    },
    async showforOnSiteVisit(item, status) {
      console.log(item);
      console.log(status);
      await this.$refs.pdsDetails_OnSiteVisit.open(item, status).then(() => {
        this.componentKey = Math.random();
      });
    },
    async showforONURetrieval(item, status) {
      console.log(item);
      console.log(status);
      await this.$refs.pdsDetails_ONURetrieval.open(item, status).then(() => {
        this.componentKey = Math.random();
      });
    },
    async showforChangeNap(item, status) {
      console.log(item);
      console.log(status);
      await this.$refs.pdsDetails_forChangeNap.open(item, status).then(() => {
        this.componentKey = Math.random();
      });
    },
    async showActivated(item, status) {
      console.log(item);
      console.log(status);
      await this.$refs.pdsDetails_Activated.open(item, status).then(() => {
        this.componentKey = Math.random();
      });
    },
    exportExcel(items) {
      let exportData = items.map((item) => {
        return {
          "Distributor Name": item.distributorName,
          "For Confirmation": item.forConfirmation,
          Interested: item.interested,
          "On-Site Visit": item.onSiteVisit,
          "For Installation": item.forInstallation,
          "ONU Retrieval": item.onuRetrieval,
          "For ChangeNap": item.forChangeNap,
          Activated: item.activated,
        };
      });
      this.fileName = `PDS_REPORTS`;
      this.exportData = exportData;
    },
  },

  created() {
    this.getList();
    // console.log(this.$props.headers);
  },

  watch: {
    dates(e) {
      if (e.length > 1) {
        this.getList();
      }
    },
    // options: {
    //   handler() {
    //     this.getList(this.search);
    //   },
    //   deep: true,
    // },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>

<style scoped>
.p-0 {
  padding: 0px !important;
}

.sub-areas>div>table>thead>tr {
  background-color: red;
  border-radius: 10px;
}
</style>
